// src/data/ProductsDetails.js

import { CheckInImg, Classmanagement, Ldmanagement, Membermanagement } from "../assets/images/images";

const ProductsDetails = [
    {
        id: 1,
        title: "Member Management",
        desc: "Effortless Member Tracking & Engagement",
        description: [
            "Simplify member sign-ups with a user-friendly interface.",
            "Manage all member details from a centralized dashboard.",
            "Access contact information, billing history, and membership plans in one place.",
            "Offer flexible membership options to match different schedules and preferences."
        ],
        image: Membermanagement,
        link: "Find Out More →",
        route: "/easymembr"
    },
    {
        id: 2,
        title: "Class Management",
        desc: "Seamless Scheduling for a Smooth Workflow",
        description: [
            "Create & manage class schedules with ease",
            "Assign trainers & track attendance.",
            "Send automated booking reminders."
        ],
        image: Classmanagement,
        link: "Find Out More →",
        route: "/easybook"
    },
    // {
    //     id: 3,
    //     title: "Lead Management",
    //     desc: "Convert More Leads & Grow Your Business",
    //     description: [
    //         "Automated lead capture & follow-ups",
    //         "Structured pipeline for tracking prospects.",
    //         "Integration with email, WhatsApp, & SMS."
    //     ],
    //     image: Ldmanagement,
    //     link: "Find Out More →"
    // },
];

export default ProductsDetails;
